import { render, staticRenderFns } from "./IntegrationsSection.vue?vue&type=template&id=59a80a6c&scoped=true"
import script from "./IntegrationsSection.vue?vue&type=script&lang=js"
export * from "./IntegrationsSection.vue?vue&type=script&lang=js"
import style0 from "./IntegrationsSection.vue?vue&type=style&index=0&id=59a80a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a80a6c",
  null
  
)

export default component.exports